import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import rdcStrings from 'features/rdc/rdcStrings.en';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';
import theme from 'shared/styles/theme';
import { downloadVaroApp } from 'shared/utils/downloadVaroApp';

export default function DisclosureScreen() {
  const router = useRouter();
  const { t: translatedText } = useTranslation('rdc', {
    keyPrefix: 'disclosure',
  });
  const { disclosure } = rdcStrings;

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <ActionScreen
        visual="PHONE_A"
        includeDefaultPadding={false}
        titleText={translatedText('disclosure.webTitle', disclosure.webTitle)}
        titleTextStyle="extra-large"
        bodyContent={
          <BodyBaseText style={styles.contentText} numberOfLines={3}>
            {translatedText('disclosure.webContent', disclosure.webContent)}
          </BodyBaseText>
        }
        primaryButton={{
          label: translatedText('buttons.getApp', disclosure.buttons.getApp),
          onPress: downloadVaroApp,
        }}
        secondaryButton={{
          label: translatedText('buttons.close', disclosure.buttons.close),
          onPress: () => router.replace('/move-money'),
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    flexDirection: 'column',
    flexGrow: 1,
    zIndex: 1,
  },
  contentText: {
    paddingHorizontal: theme.spacing.m,
    textAlign: 'left',
  },
});
